(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["moonstar-product-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('moonstar-product-reviews')) {
  class MoonstarProductReviews extends HTMLElement {
    static visible = new Set();
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.mount = this.querySelector('.ms-pr__mount');
      this.navigation = this.querySelector('.ms-pr__navigation');
      this.slider = this.querySelector('.ms-pr__slider');
      this.status = this.querySelector('.ms-pr__status');
      this.write = this.querySelector('[data-ms-write]');
      this.writeRow = this.querySelector('.ms-pr__write-row');
      this.retry = this.querySelector('.ms-pr__retry');
      try { this.productMedia = JSON.parse(this.querySelector('[data-ms-product-media]').textContent); }
      catch { this.productMedia = null; }
      this.setAttribute('data-warming', '');
      this.schedule = () => {
        if (this.frame || !this.isConnected) return;
        this.frame = requestAnimationFrame(() => { this.frame = 0; this.refresh(); });
      };
      this.observer = new MutationObserver(this.schedule);
      this.observer.observe(this.mount, { childList: true, subtree: true });
      this.resize = new ResizeObserver(() => this.syncArrows());
      this.slider.addEventListener('input', () => {
        if (!this.list) return;
        this.list.scrollLeft = Math.max(0, this.list.scrollWidth - this.list.clientWidth) * Number(this.slider.value) / 100;
      }, { signal });
      this.retry.addEventListener('click', () => {
        // Reinserting only the uninitialised placeholder lets Growave retry its normal injector.
        if (this.mount.querySelector('.gw-rv-reviews-list-widget')) { location.reload(); return; }
        const placeholder = this.mount.cloneNode(false);
        this.observer.disconnect();
        this.mount.replaceWith(placeholder); this.mount = placeholder;
        this.observer.observe(this.mount, { childList: true, subtree: true });
        this.status.textContent = this.dataset.loadingLabel;
        this.retry.hidden = true; this.setAttribute('data-warming', ''); this.armTimeout();
      }, { signal });
      this.write?.addEventListener('click', () => this.openWrite(), { signal });
      this.onSdkReady = () => {
        const sdk = window.gw?.sdk;
        if (!sdk || this.sdk) return;
        this.sdk = sdk;
        sdk.runIfModuleReady(sdk.common.constants.modules.REVIEWS, () => {
          queueMicrotask(() => {
            if (!this.isConnected) return;
            this.reviewsReady = true;
            if (this.write) this.write.disabled = false;
          });
        });
      };
      document.addEventListener('gwSdkReady', this.onSdkReady, { signal });
      this.onSdkReady();
      if (this.dataset.clearLaunchers === 'true') {
        this.visibility = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) MoonstarProductReviews.visible.add(this);
          else MoonstarProductReviews.visible.delete(this);
          document.documentElement.classList.toggle('ms-pr-in-view', MoonstarProductReviews.visible.size > 0);
        });
        this.visibility.observe(this);
      }
      this.armTimeout(); this.schedule();
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => this.enrichSchema(), { once: true, signal });
      else this.enrichSchema();
    }
    enrichSchema() {
      const payload = this.querySelector('[data-ms-rating-data]');
      if (!payload) return;
      let rating;
      try { rating = JSON.parse(payload.textContent); } catch { return; }
      if (!rating.url || !Number.isFinite(rating.ratingValue) || rating.ratingValue <= 0 || rating.ratingValue > 5 || !Number.isInteger(rating.reviewCount) || rating.reviewCount < 1) return;
      const sameProduct = node => {
        if (!node || typeof node !== 'object') return false;
        const types = Array.isArray(node['@type']) ? node['@type'] : [node['@type']];
        return types.includes('Product') && node['@id'] === `${rating.url}#product`;
      };
      for (const script of document.querySelectorAll('script[type="application/ld+json"]')) {
        let json;
        try { json = JSON.parse(script.textContent); } catch { continue; }
        if (!json || typeof json !== 'object') continue;
        const nodes = Array.isArray(json) ? json : json['@graph'] || [json];
        if (!Array.isArray(nodes)) continue;
        const product = nodes.find(sameProduct);
        if (!product) continue;
        product.aggregateRating = { '@type': 'AggregateRating', ratingValue: rating.ratingValue, reviewCount: rating.reviewCount, bestRating: 5, worstRating: 1 };
        script.textContent = JSON.stringify(json).replace(/</g, '\\u003c');
        this.dataset.msSchema = 'updated';
        return;
      }
      // Do not guess which Product/variant to change or create a duplicate entity.
      this.dataset.msSchema = 'unmatched';
    }
    armTimeout() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        if (this.hasAttribute('data-ready')) return;
        this.removeAttribute('data-warming');
        this.status.textContent = this.dataset.loadingLabel;
        this.retry.hidden = false;
      }, 12000);
    }
    refresh() {
      const controls = this.mount.querySelector('.gw-rv-list-settings__content');
      if (controls && this.writeRow && this.writeRow.parentElement !== controls) controls.prepend(this.writeRow);
      const list = this.mount.querySelector('.gw-rv-list');
      const empty = this.mount.querySelector('.gw-rv-reviews-list-widget__empty-list-wrapper');
      if (list && list !== this.list) {
        this.finishDrag?.();
        this.listController?.abort(); this.resize.disconnect();
        this.listController = new AbortController();
        this.list = list;
        list.tabIndex = 0;
        list.setAttribute('role', 'list');
        list.setAttribute('aria-label', this.dataset.carouselLabel);
        list.addEventListener('scroll', () => this.syncArrows(), { passive: true, signal: this.listController.signal });
        this.enableDrag(list, this.listController.signal);
        list.addEventListener('keydown', event => {
          if (event.target !== list || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault(); this.advance(event.key === 'ArrowRight' ? 1 : -1);
        }, { signal: this.listController.signal });
        this.resize.observe(list);
      }
      const cards = list ? Array.from(list.children).filter(node => node.classList.contains('gw-rv-item')) : [];
      if (this.firstCard && cards[0] && this.firstCard !== cards[0]) list.scrollLeft = 0;
      this.firstCard = cards[0];
      cards.forEach(card => this.styleCard(card));
      if (cards.length || empty) {
        this.setAttribute('data-ready', '');
        this.toggleAttribute('data-empty', Boolean(empty && !cards.length));
        this.querySelector('.ms-pr__empty').hidden = !empty || Boolean(cards.length);
        this.removeAttribute('data-warming');
        this.status.textContent = ''; this.retry.hidden = true;
        clearTimeout(this.timeout);
      }
      this.navigation.hidden = !cards.length;
      this.syncArrows();
    }
    styleCard(card) {
      if (card.dataset.msStyled) { this.syncProductImage(card); return; }
      const root = card.firstElementChild;
      if (!root?.classList.contains('gw-block-stack')) return;
      const [rating, content] = root.children;
      const main = content?.firstElementChild;
      if (!rating || !content || !main?.classList.contains('gw-block-stack')) return;
      const [author, body] = main.children;
      const mark = (node, part) => { if (node) node.dataset.msPart = part; };
      mark(root, 'root'); mark(rating, 'rating'); mark(content, 'content'); mark(main, 'main');
      mark(rating.firstElementChild, 'stars'); mark(rating.lastElementChild, 'date');
      mark(author, 'author'); mark(body, 'body');
      const name = author.querySelector('[slot="author"]') || author.querySelector('p');
      if (name?.parentElement?.classList.contains('gw-inline-stack')) mark(name.parentElement, 'name-row');
      const title = body?.lastElementChild?.querySelector(':scope > p:not([slot="text"])');
      mark(title, 'title');
      if (title) { title.setAttribute('role', 'heading'); title.setAttribute('aria-level', '3'); }
      Array.from(content.children).slice(1).forEach(node => {
        if (node.classList.contains('gw-rv-item-image-list')) return;
        if (node.classList.contains('gw-inline-stack')) {
          mark(node, 'meta');
          const action = node.querySelector('.gw-rv-toggle-vote') || node.querySelector('button');
          mark(action, 'action');
          if (node.firstElementChild !== action) mark(node.firstElementChild, 'labels');
        } else mark(node, 'reply');
      });
      card.querySelectorAll('.gw-rv-item-image-list img').forEach(image => {
        image.loading = 'lazy'; image.decoding = 'async';
        if (!image.hasAttribute('width')) image.width = 90;
        if (!image.hasAttribute('height')) image.height = 90;
      });
      card.dataset.msStyled = 'true';
      this.syncProductImage(card);
    }
    syncProductImage(card) {
      const existing = card.querySelector('.ms-pr__product-image');
      const photos = card.querySelector('.gw-rv-item-image-list');
      if (photos?.children.length) { existing?.remove(); return; }
      const media = this.productMedia;
      if (!media) return;
      const linkedProduct = card.querySelector('.gw-rv-product img');
      const productLink = card.querySelector('[data-ms-part="author"] a[href*="/products/"]');
      if (productLink && !linkedProduct) { existing?.remove(); return; }
      if (linkedProduct && !linkedProduct.getAttribute('src')) { existing?.remove(); return; }
      let source = linkedProduct?.getAttribute('src') || media.image;
      const title = linkedProduct?.alt || productLink?.textContent?.trim() || media.title || '';
      if (!source) return;
      try {
        const url = new URL(source, document.baseURI);
        if (url.hostname === 'cdn.shopify.com' || url.hostname.endsWith('.shopifycdn.com') || (url.origin === location.origin && url.pathname.startsWith('/cdn/shop/'))) {
          // Start from the uncropped Shopify asset, including legacy thumbnail URLs.
          url.pathname = url.pathname.replace(/_(?:\d+x\d*|x\d+|small|medium|large|grande|compact|thumb)(?:_crop_(?:top|center|bottom|left|right))?(?=\.[^/.]+$)/i, '');
          ['height', 'crop', 'crop_left', 'crop_top', 'crop_width', 'crop_height'].forEach(key => url.searchParams.delete(key));
          url.searchParams.set('width', '480');
          source = url.href;
        }
      } catch { return; }
      const productDescription = [productLink?.textContent, linkedProduct?.alt, productLink?.getAttribute('href'), title].filter(Boolean).join(' ');
      const isSet = /(?:^|[^a-z])(sets?|stacks?|bundles?)(?:[^a-z]|$)/i.test(productDescription);
      if (existing?.dataset.msSource === source) {
        if (isSet) existing.dataset.msFit = 'contain';
        return;
      }
      const container = existing || document.createElement('div');
      container.className = 'ms-pr__product-image';
      container.dataset.msSource = source;
      container.dataset.msFit = isSet ? 'contain' : 'cover';
      const image = document.createElement('img');
      image.src = source; image.alt = title; image.width = 360; image.height = 360;
      image.loading = 'lazy'; image.decoding = 'async';
      image.addEventListener('load', () => {
        if (image.naturalWidth >= image.naturalHeight * 1.25) container.dataset.msFit = 'contain';
      }, { once: true });
      image.addEventListener('error', () => { container.hidden = true; }, { once: true });
      container.replaceChildren(image);
      if (!existing) card.querySelector('[data-ms-part="content"]')?.append(container);
    }
    advance(direction) {
      const card = this.list?.firstElementChild;
      if (!card) return;
      this.list.scrollBy({ left: (card.getBoundingClientRect().width + 16) * direction, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    enableDrag(list, signal) {
      let drag;
      this.finishDrag = () => {
        if (!drag) return;
        const current = drag;
        drag = null;
        list.removeAttribute('data-dragging');
        if (list.hasPointerCapture(current.id)) list.releasePointerCapture(current.id);
      };
      list.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'mouse' || event.button !== 0 || list.scrollWidth <= list.clientWidth || event.target.closest('button,a,input,select,textarea,[role="button"]')) return;
        drag = { id: event.pointerId, x: event.clientX, left: list.scrollLeft, moved: false };
      }, { signal });
      list.addEventListener('pointermove', event => {
        if (!drag || event.pointerId !== drag.id) return;
        const distance = event.clientX - drag.x;
        if (!drag.moved && Math.abs(distance) < 6) return;
        if (!drag.moved) {
          drag.moved = true;
          list.setAttribute('data-dragging', '');
          list.setPointerCapture(drag.id);
        }
        event.preventDefault();
        list.scrollLeft = drag.left - distance;
      }, { signal });
      list.addEventListener('pointerleave', () => { if (drag && !drag.moved) this.finishDrag(); }, { signal });
      list.addEventListener('pointerup', this.finishDrag, { signal });
      list.addEventListener('pointercancel', this.finishDrag, { signal });
      list.addEventListener('lostpointercapture', this.finishDrag, { signal });
      list.addEventListener('dragstart', event => { if (drag) event.preventDefault(); }, { signal });
    }
    syncArrows() {
      const end = this.list ? Math.max(0, this.list.scrollWidth - this.list.clientWidth) : 0;
      if (this.slider && this.list) {
        const left = Math.max(0, Math.min(end, this.list.scrollLeft));
        this.slider.value = end ? String(left / end * 100) : '0';
        this.navigation.style.setProperty('--ms-progress', `${Math.min(100, (left + this.list.clientWidth) / Math.max(1, this.list.scrollWidth) * 100)}%`);
      }
      if (this.navigation) this.navigation.hidden = end <= 1;
    }
    async openWrite() {
      if (this.dataset.signedIn !== 'true' || !this.reviewsReady || !this.write) return;
      this.write.disabled = true;
      try {
        const response = await this.sdk.reviews.methods.openLeaveReviewModal({ productId: Number(this.dataset.productId) });
        if (response?.error) throw new Error(response.error.message || 'Growave review form unavailable');
        // Growave performs verified-purchase and previous-review checks on its own server.
        this.status.textContent = '';
      } catch (error) { this.status.textContent = this.dataset.openReviewLabel; }
      finally { if (this.isConnected) this.write.disabled = false; }
    }
    disconnectedCallback() {
      this.finishDrag?.();
      this.controller?.abort(); this.controller = null;
      this.listController?.abort(); this.observer?.disconnect(); this.resize?.disconnect(); this.visibility?.disconnect();
      clearTimeout(this.timeout); cancelAnimationFrame(this.frame); this.frame = 0;
      this.sdk = null; this.reviewsReady = false;
      MoonstarProductReviews.visible.delete(this);
      document.documentElement.classList.toggle('ms-pr-in-view', MoonstarProductReviews.visible.size > 0);
    }
  }
  customElements.define('moonstar-product-reviews', MoonstarProductReviews);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('moonstar-growave-slider')) {
  customElements.define('moonstar-growave-slider', class extends HTMLElement {
    connectedCallback() {
      if (this.observer) return;
      this.reviews = new Map();
      this.products = new Map();
      this.storefrontProducts = new Map();
      this.productChecks = new Map();
      this.productController = new AbortController();
      this.subscriptions = [];
      this.requestedProducts = new Set();
      this.productTimers = new Map();
      this.weights = new Map();
      this.pools = { all: { offset: 0 } };
      this.display = this.querySelector('.ms-review-display');
      this.track = this.display.querySelector('.gw-slider__track');
      this.viewport = this.display.querySelector('.gw-slider__slides');
      this.navigation = this.display.querySelector('.ms-review-navigation');
      this.slider = this.display.querySelector('.ms-review-slider');
      this.schedule = () => {
        if (this.frame || !this.isConnected) return;
        this.frame = requestAnimationFrame(() => { this.frame = 0; this.updateCards(); });
      };
      this.observer = new MutationObserver(this.schedule);
      this.observer.observe(this.querySelector('.ms-review-sources'), { childList: true, subtree: true });
      this.onDisplayClick = event => {
        const card = event.target.closest('[data-ms-review-id]');
        if (card) this.sourcesByReview?.get(card.dataset.msReviewId)?.click();
      };
      this.onSliderInput = () => {
        const end = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
        this.viewport.scrollLeft = end * Number(this.slider.value) / 100;
      };
      this.onScroll = () => this.syncSlider();
      this.onKey = event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.advance(event.key === 'ArrowRight' ? 1 : -1);
      };
      this.track.addEventListener('click', this.onDisplayClick);
      this.slider.addEventListener('input', this.onSliderInput);
      this.viewport.addEventListener('scroll', this.onScroll, { passive: true });
      this.viewport.addEventListener('keydown', this.onKey);
      this.resizeObserver = new ResizeObserver(this.onScroll);
      this.resizeObserver.observe(this.viewport);
      this.retryButton = this.querySelector('.ms-review-retry');
      this.retry = () => {
        this.removeAttribute('data-ms-error');
        this.productChecks.clear();
        this.selection = null;
        for (const pool of Object.values(this.pools)) { pool.exhausted = false; pool.offset = 0; }
        if (!this.productKit && this.sdk) this.connectProducts();
        this.loadReviews('all');
      };
      this.retryButton?.addEventListener('click', this.retry);
      this.watchdog = setTimeout(() => {
        if (!this.hasAttribute('data-ms-ready')) this.setAttribute('data-ms-error', '');
      }, 12000);
      this.onSdkReady = () => {
        const sdk = window.gw?.sdk;
        if (!sdk || this.sdk) return;
        this.sdk = sdk;
        sdk.runIfModuleReady(sdk.common.constants.modules.REVIEWS, () => {
          queueMicrotask(() => {
            this.reviewsReady = true;
            this.loadReviews('all');
          });
        });
        sdk.runIfModuleReady(sdk.common.constants.modules.PRODUCTS, () => {
          queueMicrotask(() => this.connectProducts());
        });
      };
      document.addEventListener('gwSdkReady', this.onSdkReady);
      this.onSdkReady();
    }
    async sdkCall(method) {
      for (let attempt = 0; attempt < 3; attempt++) {
        if (!this.isConnected) return;
        try {
          const response = await method();
          if (response?.result) return response.result;
          throw new Error(response?.error?.message || 'Growave request unavailable');
        } catch (error) {
          if (attempt === 2) throw error;
          await new Promise(resolve => { this.retryTimer = setTimeout(resolve, 100 * (attempt + 1)); });
        }
      }
    }
    async connectProducts() {
      try {
        const kit = await this.sdkCall(() => this.sdk.products.methods.getProductsSharedStateKit());
        if (!this.isConnected || !kit?.query) return;
        this.productKit = kit;
        this.subscriptions.push(kit.query.selectAll().subscribe(products => {
          this.products = new Map(products.map(product => [product.id, product]));
          this.schedule();
        }));
      } catch (error) { this.reportError(error); }
    }
    reviewKey(body, author) {
      const normalize = value => String(value || '').replace(/\s+/g, ' ').trim();
      return JSON.stringify([normalize(body), normalize(author)]);
    }
    async loadReviews(name) {
      const pool = this.pools[name];
      if (pool.loading || pool.exhausted || !this.reviewsReady) return;
      pool.loading = true;
      try {
        const result = await this.sdkCall(() => this.sdk.reviews.methods.getReviews({
          lowestRating: 5, onlyWithMedia: false, onlyProductReviews: true,
          onlyPinnedReviews: true, perPage: 20, offset: pool.offset
        }));
        if (!this.isConnected || !result) return;
        const { items, totalCount, currentOffset } = result;
        if (!Array.isArray(items)) throw new Error('Growave review lookup unavailable');
        items.forEach(review => {
          const key = this.reviewKey(review.body, review.customer?.name);
          const entries = new Map((this.reviews.get(key) || []).map(item => [item.id, item]));
          entries.set(review.id, review);
          this.reviews.set(key, Array.from(entries.values()));
        });
        const nextOffset = (currentOffset ?? pool.offset) + items.length;
        pool.exhausted = !items.length || nextOffset >= totalCount || nextOffset <= pool.offset;
        pool.offset = nextOffset;
        pool.total = totalCount;
        pool.loaded = true;
      } catch (error) {
        pool.exhausted = true;
        pool.loaded = true;
        this.reportError(error);
      } finally {
        pool.loading = false;
        this.schedule();
      }
    }
    verifyProduct(product) {
      if (this.productChecks.has(product.id)) return;
      if (!product.handle) { this.productChecks.set(product.id, false); this.schedule(); return; }
      this.productChecks.set(product.id, 'pending');
      const root = window.Shopify?.routes?.root || '/';
      fetch(`${root}products/${encodeURIComponent(product.handle)}.js`, {
        signal: this.productController.signal, cache: 'no-cache', credentials: 'same-origin'
      }).then(async response => {
        if (!response.ok) return null;
        const current = await response.json();
        if (Number(current.id) !== Number(product.id) || !current.published_at || !current.featured_image) return null;
        if (current.status && current.status.toLowerCase() !== 'active') return null;
        return current;
      }).then(current => {
        if (!this.isConnected || this.productController.signal.aborted) return;
        this.productChecks.set(product.id, Boolean(current));
        if (current) this.storefrontProducts.set(product.id, current);
        this.schedule();
      }).catch(error => {
        if (error.name === 'AbortError') return;
        this.productChecks.set(product.id, false);
        this.schedule();
      });
    }
    fitProductImage(image) {
      try {
        const size = 160;
        const canvas = document.createElement('canvas');
        canvas.width = canvas.height = size;
        const context = canvas.getContext('2d', { willReadFrequently: true });
        if (!context || !image.naturalWidth || !image.naturalHeight) return;
        context.fillStyle = '#fff';
        context.fillRect(0, 0, size, size);
        const ratio = Math.min(size / image.naturalWidth, size / image.naturalHeight);
        const width = image.naturalWidth * ratio, height = image.naturalHeight * ratio;
        context.drawImage(image, (size - width) / 2, (size - height) / 2, width, height);
        const pixels = context.getImageData(0, 0, size, size).data;
        const corners = [0, size - 1, size * (size - 1), size * size - 1].map(index => Array.from(pixels.slice(index * 4, index * 4 + 3)));
        const background = [0, 1, 2].map(channel => corners.reduce((sum, color) => sum + color[channel], 0) / 4);
        if (corners.some(color => color.some((value, channel) => Math.abs(value - background[channel]) > 24))) return;
        let left = size, top = size, right = -1, bottom = -1, count = 0;
        for (let y = 0; y < size; y++) {
          for (let x = 0; x < size; x++) {
            const offset = (y * size + x) * 4;
            if (pixels[offset + 3] < 40 || !background.some((value, channel) => Math.abs(pixels[offset + channel] - value) > 28)) continue;
            left = Math.min(left, x); right = Math.max(right, x);
            top = Math.min(top, y); bottom = Math.max(bottom, y); count++;
          }
        }
        if (count < 32) return;
        const span = Math.max(right - left + 1, bottom - top + 1) / size;
        const scale = Math.max(1, Math.min(4, 0.86 / span));
        if (scale <= 1.05) return;
        image.style.setProperty('--ms-product-scale', scale.toFixed(3));
        image.style.setProperty('--ms-product-x', `${(0.5 - (left + right + 1) / (2 * size)) * scale * 100}%`);
        image.style.setProperty('--ms-product-y', `${(0.5 - (top + bottom + 1) / (2 * size)) * scale * 100}%`);
      } catch (error) {
        image.style.removeProperty('--ms-product-scale');
      }
    }
    requestProduct(id) {
      if (!this.productKit || this.requestedProducts.has(id)) return;
      this.requestedProducts.add(id);
      const fail = () => { this.productChecks.set(id, false); this.schedule(); };
      this.productTimers.set(id, setTimeout(fail, 4000));
      this.subscriptions.push(this.productKit.service.addProductForFetching(id).subscribe({
        next: product => {
          clearTimeout(this.productTimers.get(id));
          this.products.set(product.id, product); this.schedule();
        },
        error: () => { clearTimeout(this.productTimers.get(id)); fail(); }
      }));
    }
    updateCards() {
      if (!this.pools.all.loaded) return;
      const records = new Map(), unmatched = new Set();
      for (const name of ['all']) {
        const cards = this.querySelectorAll(`[data-ms-pool="${name}"] .gw-rv-slider-item`);
        if (!cards.length && (this.pools[name].total || 0) >= 5) return;
        cards.forEach(card => {
          const body = card.querySelector('.gw-rv-slider-item__body > :last-child')?.textContent;
          const author = card.querySelector('.gw-rv-slider-item__review-author p')?.textContent;
          const matches = this.reviews.get(this.reviewKey(body, author));
          if (!matches) { unmatched.add(name); return; }
          const image = card.querySelector('.gw-rv-slider-item__image-wrapper img');
          const review = matches.length === 1 ? matches[0] : matches.find(item => item.images?.some(photo =>
            [photo.url, ...(photo.sizes || []).map(size => size.url)].includes(image?.getAttribute('src'))
          ));
          if (!review || review.rating !== 5 || review.isPublished === false || !review.product || review.product.isDeleted || review.product.isDraft) return;
          if (this.productChecks.get(review.product.id) === false) return;
          const id = String(review.id);
          if (!this.weights.has(id)) this.weights.set(id, Math.random());
          if (!records.has(id)) records.set(id, { id, review, card });
        });
      }
      const ordered = Array.from(records.values()).sort((a, b) => this.weights.get(a.id) - this.weights.get(b.id));
      if (unmatched.has('all') && ordered.length < 6) this.loadReviews('all');
      if (this.pools.all.loading) return;
      let plan = ordered.slice(0, 6);
      if (this.selection) {
        const chosen = this.selection.map(id => records.get(id));
        if (chosen.every(Boolean)) plan = chosen;
        else this.selection = null;
      }
      let ready = true;
      for (const item of plan) {
        const id = item.review.product.id, product = this.products.get(id);
        if (!product) { this.requestProduct(id); ready = false; continue; }
        if (this.productChecks.get(id) !== true) { this.verifyProduct(product); ready = false; }
      }
      if (!ready || !plan.length) return;
      if (plan.length < 6 && unmatched.size && Object.values(this.pools).some(pool => !pool.exhausted)) return;
      if (plan.length === 6) this.selection = plan.map(item => item.id);
      this.sourcesByReview = new Map(plan.map(item => [item.id, item.card.querySelector('.gw-rv-slider-item__btn')]));
      const key = JSON.stringify(plan.map(item => [item.id, this.storefrontProducts.get(item.review.product.id)?.featured_image]));
      if (key !== this.renderKey) {
        const perPage = matchMedia('(min-width: 1000px)').matches ? 4 : matchMedia('(min-width: 700px)').matches ? 2 : 1;
        const cards = plan.map((item, index) => {
          const current = this.storefrontProducts.get(item.review.product.id);
          const card = item.card.cloneNode(true);
          card.dataset.msReviewId = item.id;
          card.setAttribute('data-ms-eligible', '');
          card.removeAttribute('aria-hidden'); card.removeAttribute('inert');
          const image = document.createElement('img');
          image.className = 'ms-product-image';
          image.width = image.height = 720;
          image.decoding = 'async'; image.crossOrigin = 'anonymous';
          image.loading = index < perPage ? 'eager' : 'lazy';
          image.alt = current.title;
          image.addEventListener('load', () => this.fitProductImage(image), { once: true });
          image.addEventListener('error', () => { image.removeAttribute('crossorigin'); image.src = image.src; }, { once: true });
          const url = new URL(current.featured_image, location.origin);
          if (url.hostname === 'cdn.shopify.com' || url.pathname.includes('/cdn/shop/')) url.searchParams.set('width', '720');
          image.src = url.href;
          card.querySelector('.gw-rv-slider-item__image-wrapper').replaceChildren(image);
          return card;
        });
        this.track.replaceChildren(...cards);
        this.viewport.scrollLeft = 0;
        this.renderKey = key;
      }
      clearTimeout(this.watchdog);
      this.setAttribute('data-ms-ready', '');
      this.removeAttribute('data-ms-error');
      this.syncSlider();
    }
    advance(direction) {
      const card = this.track.firstElementChild;
      if (!card) return;
      const step = card.getBoundingClientRect().width + 16;
      const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      this.viewport.scrollBy({ left: step * direction, behavior });
    }
    syncSlider() {
      const end = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
      const left = Math.max(0, Math.min(end, this.viewport.scrollLeft));
      this.navigation.hidden = end <= 1;
      this.slider.value = end ? String(left / end * 100) : '0';
      this.navigation.style.setProperty('--ms-progress', `${Math.min(100, (left + this.viewport.clientWidth) / Math.max(1, this.viewport.scrollWidth) * 100)}%`);
    }
    reportError(error) {
      console.warn('[Moon+Star reviews]', error);
      if (!this.hasAttribute('data-ms-ready')) this.setAttribute('data-ms-error', '');
    }
    disconnectedCallback() {
      this.observer?.disconnect(); this.observer = null;
      this.resizeObserver?.disconnect();
      document.removeEventListener('gwSdkReady', this.onSdkReady);
      this.retryButton?.removeEventListener('click', this.retry);
      this.track?.removeEventListener('click', this.onDisplayClick);
      this.slider?.removeEventListener('input', this.onSliderInput);
      this.viewport?.removeEventListener('scroll', this.onScroll);
      this.viewport?.removeEventListener('keydown', this.onKey);
      clearTimeout(this.retryTimer); clearTimeout(this.watchdog);
      this.productTimers?.forEach(timer => clearTimeout(timer));
      this.productController?.abort();
      this.subscriptions?.forEach(subscription => subscription.unsubscribe());
      cancelAnimationFrame(this.frame);
      this.frame = 0; this.sdk = null; this.productKit = null; this.reviewsReady = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
